var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-backdrop",class:{ 'brand-backdrop--adaptive': _vm.adaptive, 'brand-backdrop--fade': _vm.fade }},[_c('div',{staticClass:"brand-backdrop__glows"}),_c('div',{staticClass:"brand-backdrop__dots"}),_c('div',{staticClass:"brand-backdrop__rings"})])
}
var staticRenderFns = []

export { render, staticRenderFns }